export function getName(val, list) {
    let str = "";
    list.map((item => {
        if (item.value == val) str = item.label
    }))
    if (!str) str = '-'
    return str
}